import serviceRequest from "utils/request";

const baseUrl = "/api/remote-access-management";

export const getRemoteAccessUsers = (organizationId) => {
	return serviceRequest({
		url: `${baseUrl}/users`,
		method: "get",
		params: { organizationId },
	});
};

export const updateRemoteAccessUsers = (data) => {
	return serviceRequest({
		url: `${baseUrl}/users`,
		method: "put",
		data,
	});
};
